import { render, staticRenderFns } from "./product__form.vue?vue&type=template&id=32d53e98"
import script from "./product__form.vue?vue&type=script&lang=js"
export * from "./product__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports